var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getLeaveBehindSearchResults, getSearchResults, } from "../../../services/savvy";
import { ImpressionType } from "../../../lib/constants";
import Logger from "../../../lib/Logger";
import { ResultType } from "../../../services/savvy/constants";
import { hasDuplicateResults } from "../utils";
import { skipToken } from "@reduxjs/toolkit/query";
import useAppSelector from "../../../hooks/useAppSelector";
import { useEffect } from "react";
import useIsRemarketingSearch from "../../configuration/useIsRemarketingSearch";
var impressionType = ImpressionType.AfterClick;
export default function useLeaveBehindSearch() {
    var accountReferenceId = useAppSelector(function (state) { return state.applicant.accountReferenceId; });
    var isRemarketingSearch = useIsRemarketingSearch();
    var _a = getLeaveBehindSearchResults.useQueryState(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            impressionType: impressionType,
        }
        : skipToken, {
        selectFromResult: function (_a) {
            var data = _a.data, isSuccess = _a.isSuccess, isUninitialized = _a.isUninitialized, isLoading = _a.isLoading;
            var reducedBundles = data === null || data === void 0 ? void 0 : data.bundles.reduce(function (acc, curr) {
                var hasSameIssuer = function (item) {
                    return (item.auto.advertiserName &&
                        item.auto.advertiserName === curr.auto.advertiserName) ||
                        (Boolean(item.auto.issuerId) &&
                            item.auto.issuerId === curr.auto.issuerId);
                };
                if (acc.findIndex(hasSameIssuer) !== -1) {
                    return acc;
                }
                return __spreadArray(__spreadArray([], acc, true), [curr], false);
            }, []);
            var hasOnlyBundleAutoAds = reducedBundles === null || reducedBundles === void 0 ? void 0 : reducedBundles.every(function (result) { return result.auto.type === ResultType.Ad; });
            var hasBundleSavings = reducedBundles !== undefined &&
                reducedBundles.every(function (bundle) {
                    return bundle.auto.type === ResultType.CurrentAutoPolicy &&
                        bundle.home.type === ResultType.CurrentHomePolicy;
                }) === false;
            // We should only show the user's current auto policy as an option IF
            // there is an actual policy attached to it - not just the user's own home policy
            var hasValidAutoCurrentPolicy = reducedBundles !== undefined &&
                reducedBundles.findIndex(function (bundle) {
                    return bundle.auto.type === ResultType.CurrentAutoPolicy &&
                        bundle.home.type !== ResultType.CurrentHomePolicy;
                }) !== -1;
            return {
                currentPlan: data === null || data === void 0 ? void 0 : data.currentPlan,
                footerContent: data === null || data === void 0 ? void 0 : data.footerContent,
                mixedResults: data === null || data === void 0 ? void 0 : data.mixedResults,
                impressionId: data === null || data === void 0 ? void 0 : data.impressionId,
                quotes: data === null || data === void 0 ? void 0 : data.quotes,
                reducedBundles: hasValidAutoCurrentPolicy
                    ? reducedBundles
                    : reducedBundles === null || reducedBundles === void 0 ? void 0 : reducedBundles.filter(function (bundle) { return bundle.auto.type !== ResultType.CurrentAutoPolicy; }),
                hasBundleSavings: hasBundleSavings,
                hasValidAutoCurrentPolicy: hasValidAutoCurrentPolicy,
                hasOnlyBundleAutoAds: hasOnlyBundleAutoAds,
                isSuccess: isSuccess,
                isUninitialized: isUninitialized,
                isLoading: isLoading,
            };
        },
    }), mixedResults = _a.mixedResults, quotes = _a.quotes, reducedBundles = _a.reducedBundles, isSuccess = _a.isSuccess, isUninitialized = _a.isUninitialized, isLoading = _a.isLoading, impressionId = _a.impressionId;
    var firstSearchResults = getSearchResults.useQueryState(accountReferenceId
        ? {
            accountReferenceId: accountReferenceId,
            isRemarketingSearch: isRemarketingSearch,
            impressionType: impressionType,
        }
        : skipToken).data;
    var hasDuplicateSearchResults = hasDuplicateResults(firstSearchResults === null || firstSearchResults === void 0 ? void 0 : firstSearchResults.mixedResults, mixedResults);
    useEffect(function () {
        if (hasDuplicateSearchResults) {
            Logger.error("Error: Leave behind search has duplicate search results", {
                firstSearchId: firstSearchResults === null || firstSearchResults === void 0 ? void 0 : firstSearchResults.impressionId,
                leaveBehindSearchId: impressionId,
            });
        }
    }, [
        hasDuplicateSearchResults,
        impressionId,
        firstSearchResults === null || firstSearchResults === void 0 ? void 0 : firstSearchResults.impressionId,
    ]);
    return {
        mixedResults: mixedResults,
        quotes: quotes,
        reducedBundles: reducedBundles,
        isSuccess: isSuccess,
        isUninitialized: isUninitialized,
        isLoading: isLoading,
    };
}
